// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from reply.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function ReplyIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.707.293a1 1 0 0 1 .083 1.32l-.083.094L5.415 4H8a6 6 0 1 1 0 12 1 1 0 0 1 0-2 4 4 0 1 0 0-8H5.415l2.292 2.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083-4-4a1 1 0 0 1-.083-1.32l.083-.094 4-4a1 1 0 0 1 1.414 0Z"
      />
    </svg>
  );
}
